// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AYDx","index":"styles_index__3wkEK"};